import { APP_COLOR } from '@/theme/color';
import type { PointerEvent, ReactNode } from 'react';

interface ControlButtonProps {
  readonly direction: 'UP' | 'DOWN' | 'LEFT' | 'RIGHT';
  readonly icon: ReactNode;
  readonly isDisabled?: boolean;
  readonly isHighlighted?: boolean;
}

export function ControlButton({
  direction,
  icon,
  isDisabled = false,
  isHighlighted = false,
}: ControlButtonProps) {
  const handlePointerDown = (event: PointerEvent<HTMLButtonElement>) => {
    if (isDisabled) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    window.dispatchEvent(new CustomEvent('maze-move', { detail: { direction } }));
  };

  return (
    <button
      type="button"
      onPointerDown={handlePointerDown}
      aria-label={`Move ${direction.toLowerCase()}`}
      aria-disabled={isDisabled}
      className="flex h-[50px] w-[50px] items-center justify-center rounded-[10px] border-2 shadow-xl transition-all active:scale-95"
      style={{
        background: APP_COLOR.controlSurface,
        borderColor: isHighlighted ? APP_COLOR.infoSoft60 : APP_COLOR.accentSoft20,
        color: isHighlighted ? APP_COLOR.infoBright : APP_COLOR.accent,
        opacity: isDisabled && !isHighlighted ? 0.2 : 1,
        cursor: isDisabled && !isHighlighted ? 'not-allowed' : 'pointer',
        boxShadow: isHighlighted
          ? `0 0 0 2px ${APP_COLOR.infoSoft40}, 0 0 24px ${APP_COLOR.infoGlow}`
          : undefined,
        animation: isHighlighted ? 'pulse 2s ease-in-out infinite' : undefined,
      }}
    >
      {icon}
    </button>
  );
}
